const getDefaultPath = (cashierPath: string, type: string, name: string) => {
  if (cashierPath === "wallet_landing") {
    return "wallet_landing";
  }
  const isPathDeposit = cashierPath === "deposit";
  if (isPathDeposit && type === "coin" && name !== "") {
    return `${cashierPath}-${name}`;
  }
  return "home";
};

export default getDefaultPath;
